import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { ViewerActorModel } from 'src/app/models/viewer/viewer-actor.model';


export const AwaitingRedirectModalOptions: NgbModalOptions = {
  keyboard: false,
  centered: true,
  size: 'lg',
  backdrop: 'static'
};

@Component({
    templateUrl: './performed-action-awaiting-redirect.modal.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PerformedActionAwaitingRedirectModal {
  @Input() actions!: ViewerActorModel[];
  @Input() documents!: any[];
  @Input() requestStatus!: string;
}
